<script setup lang="ts">
import TariffCTA from '@plf/components/layout/tariff/TariffCTA.vue'

const { activeCompany } = storeToRefs(useAccountStore())

const isSubscriptionExpired = computed(() => !activeCompany.value?._tariff?._active)
</script>

<template lang="pug">
.page-disabled-background.position-fixed.t-0.b-0.l-0.r-0.z-index-1
.position-fixed.flex-center-center.t-0.b-0.l-0.r-0.z-index-1
  TariffCTA(label="layout.cto.pro_page" :variant="isSubscriptionExpired ? 'expired' : undefined" :showExpiration="false" :mini="false")
    template(#default="{ to }")
      UiButton.w-180.m-b-12.m-t-20(label="layout.cto.go_pro" :variant="ButtonVariant.Accent" :to="to" :size="Sizes.Luke")
</template>

<style scoped>
.page-disabled-background {
  background: color-mix(in srgb, var(--cue-static-neutral-primary) 50%, transparent);
}
</style>
